import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressLaoVillageSlice = createSlice({
    name: "getAddressLaoVillage",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressLaoVillageSlice_actions = getAddressLaoVillageSlice.actions;
export var fetchData = _getAddressLaoVillageSlice_actions.fetchData, fetchDataSuccess = _getAddressLaoVillageSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressLaoVillageSlice_actions.fetchDataFailure, resetState = _getAddressLaoVillageSlice_actions.resetState;
export default getAddressLaoVillageSlice.reducer;
